export type timeUnit = 'ms' | 'sec' | 'min' | 'hour' | 'day' 

export const IsLaterThanNumberOfDays = (date: Date, numberOfDays: number) => {
    return date < new Date((new Date()).setDate(-numberOfDays));
}
